export const RESET_STATE = 'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/RESET_STATE';
export const SET_SYSTEM_SOFTWARES =
	'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/SET_SYSTEM_SOFTWARES';
export const UPDATE_SYSTEM_SOFTWARES =
	'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/UPDATE_SYSTEM_SOFTWARES';

export const EDIT_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/EDIT_BATCH_LIST_ITEM';
export const REMOVE_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/REMOVE_BATCH_LIST_ITEM';
export const ADD_BATCH_LIST_ITEM_ROW =
	'GLOBAL_ADMINISTRATION_SYSTEM_SOFTWARES/ADD_BATCH_LIST_ITEM_ROW';

export function setSystemSoftwares(payload) {
	return {
		type: SET_SYSTEM_SOFTWARES,
		payload,
	};
}

export function updateSystemSoftwares(payload) {
	return {
		type: UPDATE_SYSTEM_SOFTWARES,
		payload,
	};
}

export function resetState() {
	return {
		type: RESET_STATE,
	};
}

export function editBatchListItem(payload) {
	return {
		type: EDIT_BATCH_LIST_ITEM,
		payload,
	};
}

export function removeBatchListItem(payload) {
	return {
		type: REMOVE_BATCH_LIST_ITEM,
		payload,
	};
}

export function addBatchListItemRow() {
	return {
		type: ADD_BATCH_LIST_ITEM_ROW,
	};
}
